// extracted by mini-css-extract-plugin
export default {"chart_box":"BeforeAndAfterRenovation_chart_box__VtPHA","spin_box":"BeforeAndAfterRenovation_spin_box__e2B+i","empty_box":"BeforeAndAfterRenovation_empty_box__sTecH"};